export default {
  section: {
    title: 'Synthèse de votre transmission'
  },
  levers: {
    title: 'Leviers d\'action :',
    list: {
      savingsMonthly: 'Capacité d\'épargne mensuelle',
      funeralInsurance: 'Détention d\'assurance obsèques',
      savingsAvailable: 'Epargne disponible',
    },
    risk: {
      title: 'Niveau de risque de votre patrimoine',
      subtitle: 'En comparaison avec votre profil investisseur',
      legend: {
        profile: 'Votre profil investisseur',
        patrimony: 'Niveau de risque projeté du patrimoine'
      }
    }
  },
  protection: {
    title: 'Besoins de protection de vos proches en cas de décès',
    cover: {
      title: 'Couverture décès actuelle',
      subtitle: 'Couverture actuelle vs. besoins nécessaires'
    }
  }
}
